import classnames from 'classnames';
import React, { useContext } from 'react';
import { MenuItem } from 'react-bootstrap-typeahead';

import { TypeaheadOptionType } from 'root/widgets/common-components';

import SearchWithFilterContext from 'root/widgets/search-with-filter/context';
import { extractDataAutomationId } from 'root/widgets/utils';

import './recent-search.scss';
import { RecentSearchItemProps, RecentSearchesProps } from './types';
import { prepareFloorAreaRange, preparePriceRange } from './utils';

const RecentSearchItem: React.FC<RecentSearchItemProps> = (props) => {
  const { className, search, position, metadata, onSearchSelect } = props;
  const context = useContext(SearchWithFilterContext);
  const { data, category } = context;
  const { filters } = data;
  const priceRangeData = filters['priceRange'];
  const inputData = priceRangeData[category];
  const priceRange = preparePriceRange(search.titles.minprice, search.titles.maxprice, inputData);

  const floorAreaConfig = filters['floorAreaRange'];
  const floorAreaRange =
    floorAreaConfig && prepareFloorAreaRange(search.titles.minsize, search.titles.maxsize, floorAreaConfig[category]);

  const handleClick = () => {
    if (onSearchSelect) {
      onSearchSelect(search);
    }
  };

  return (
    <MenuItem
      className={classnames('recent-searches-item-root', className)}
      option={{ ...search, displayText: '', optionType: TypeaheadOptionType.RecentSearch }}
      position={position}
      onClick={handleClick}
      {...extractDataAutomationId(metadata)}
    >
      <i className="pgicon-clock" />
      <div className="recent-search-wrapper">
        {search.titles.freetext && (
          <div className="primary-title">
            <span>{search.titles.freetext}</span>
          </div>
        )}
        <div className="secondary-title">
          <span>{search.titles.listing_type}</span>
          {search.titles.property_type_code && <span>{search.titles.property_type_code}</span>}
          {priceRange && <span>{priceRange}</span>}
        </div>
        {search.titles.beds && (
          <div className="tertiary-title">
            <span>{search.titles.beds}</span>
          </div>
        )}
        {floorAreaRange && (
          <div className="tertiary-title">
            <span>{floorAreaRange}</span>
          </div>
        )}
      </div>
    </MenuItem>
  );
};

const RecentSearches: React.FC<RecentSearchesProps> = (props) => {
  const { className, title, items, positions, metadata, onSearchSelect } = props;

  return (
    <div {...extractDataAutomationId(metadata)}>
      {items?.length > 0 && <div className="recent-search-headline">{title}</div>}
      {items.map((item, idx) => (
        <RecentSearchItem
          className={className}
          key={`recent-search-${item.time}`}
          option={item}
          position={positions[idx]}
          search={item}
          onSearchSelect={onSearchSelect}
          metadata={{
            dataAutomationId: metadata?.dataAutomationId ? `${metadata.dataAutomationId}-${idx}` : '',
          }}
        />
      ))}
    </div>
  );
};

RecentSearches.displayName = 'RecentSearches';

export default RecentSearches;
